<nav class="navbar-default navbar-static-side" style="position: fixed" role="navigation">
  <div class="sidebar-collapse logo">
    <p-scrollPanel [style]="{ width: '100%', height: '80vh' }" styleClass="custombar1">
      <ul class="nav metismenu shadow-md" id="side-menu">
        <li class="nav-header p-0" aria-hidden="true">
          <div class="card border-0 p-2 m-0">
            <div class="card-body p-0" (click)="viewUserDetail()" role="button">
              <i class="fa fa-user float-left pt-2"></i>
              <h5 class="card-title pl-4">{{ userService.getUserFullName() }}</h5>
              <h6 class="card-subtitle mb-2 text-muted pl-4">{{ userService.getUser()?.person?.position }}</h6>
            </div>
          </div>
        </li>
        <li class="pb-0 pt-1" [ngClass]="{ active: activeRoute('mainView') }">
          <a routerLink="/mainView" (click)="miniNavControl()" role="link" title="{{ 'Navigation.start' | translate }}">
            <i class="fa fa-th-large" aria-hidden="true"></i>
            <span class="nav-label">{{ 'Navigation.start' | translate }}</span>
          </a>
        </li>
        <li class="pb-1 pt-1" [ngClass]="{ active: activeRoute('tasks') }">
          <a routerLink="/tasks" (click)="miniNavControl()" role="link" title="{{ 'General.pendingTasks' | translate }}">
            <i class="fa fa-inbox" aria-hidden="true">
              <!-- EN ACCESO EN MODO MESA NO SE MUESTRA EL NUMERO DE TAREAS  -->
              <p *ngIf="numTareas && !loading && !userService.getModoAcceso()" class="badge badge-danger" aria-hidden="true">{{ numTareas }}</p>
              <p *ngIf="loading && !userService.getModoAcceso()" class="badge badge-danger text-right" aria-hidden="true">
                &nbsp;&nbsp; <i class="fas fa-sync-alt loading-spin" aria-hidden="true"></i>
              </p>
            </i>
            <span class="nav-label">{{ 'General.pendingTasks' | translate }}</span>
          </a>
        </li>
        <li class="pb-1 pt-1" [ngClass]="{ active: activeRoute('dossiersView/EXP') }" *ngIf="userService.hasRolesInApp('CONTRATACION') && !userService.getModoAcceso()">
          <a routerLink="/dossiersView/EXP" (click)="miniNavControl()" role="link" title="{{ 'General.exp' | translate }}">
            <i class="fa fa-archive" aria-hidden="true"></i>
            <span class="nav-label">{{ 'General.exp' | translate }}</span>
          </a>
        </li>
        <li
          class="pb-1 pt-1"
          [ngClass]="{ active: activeRoute('dossiersView/CONTRACTS') }"
          *ngIf="(userService.hasRolesInApp('CONTRATACION') || userService.hasRolesInApp('RECO')) && !userService.getModoAcceso()"
        >
          <a routerLink="/dossiersView/CONTRACTS" (click)="miniNavControl()" role="link" title="{{ 'Reg. Contratos' }}">
            <i class="fa fa-file-contract" aria-hidden="true"></i>
            <span class="nav-label">{{ 'Contracts.reg.nav.title' | translate }}</span>
          </a>
        </li>
        <li
          class="pb-1 pt-1"
          [ngClass]="{ active: activeRoute('dossiersView/CONTRACTS_RECO') }"
          *ngIf="appConfig.getValue('dossier-view.search.CONTRACTS_RECO') && userService.hasRolesInApp('RECO') && !userService.getModoAcceso()"
        >
          <a routerLink="/dossiersView/CONTRACTS_RECO" (click)="miniNavControl()" role="link" title="{{ 'Reg. Contratos - RECO' }}">
            <i class="fa fa-file-contract" aria-hidden="true"></i>
            <span class="nav-label">{{ 'Contracts.reg.nav.titleReco' | translate }}</span>
          </a>
        </li>
        <li class="pb-1 pt-1" [ngClass]="{ active: activeRoute('calendar') }" *ngIf="!userService.getModoAcceso() && this.calendarEnabled">
          <a routerLink="/calendar" (click)="miniNavControl()" role="link" title="{{ 'General.calendar' | translate }}">
            <i class="fa fa-calendar" aria-hidden="true"></i>
            <span class="nav-label">{{ 'General.calendar' | translate }}</span>
          </a>
        </li>
        <!-- <li class="pb-1 pt-1" [ngClass]="{active: activeRoute('documents')}">
                <a routerLink="/documents"><i class="fa fa-files-o  fa-2x text-navy" aria-hidden="true" ></i> <span class="nav-label">{{ 'Navigation.documents' | translate }}</span> </a>
            </li> -->
        <li class="pb-1 pt-1" [ngClass]="{ active: activeRoute('dossiersView/SARGA_EXPTE_PRESUP') }" *ngIf="userService.hasRolesInApp('PRESUPUESTARIO') && !userService.getModoAcceso()">
          <a routerLink="/dossiersView/SARGA_EPTE_PRESUP" (click)="miniNavControl()" role="link" title="{{ 'Exp. Sarga' }}">
            <i class="fa fa-play" aria-hidden="true"></i>
            <span class="nav-label">{{ 'Exptes. Presup.' | translate }}</span>
          </a>
        </li>
        <li class="pb-1 pt-1" [ngClass]="{ active: activeRoute('dossiersView/SARGA_EXPTE_ENCARGOS') }" *ngIf="userService.hasRolesInApp('ENCARGOS') && !userService.getModoAcceso()">
          <a routerLink="/dossiersView/SARGA_EXPTE_ENCARGOS" (click)="miniNavControl()" role="link" title="{{ 'Exp. Sarga' }}">
            <i class="fa fa-play" aria-hidden="true"></i>
            <span class="nav-label">{{ 'Exptes. Encargos' | translate }}</span>
          </a>
        </li>
        <li class="pb-1 pt-1" [ngClass]="{ active: activeRoute('dossiersView/INFRASTRUCTUREPLAN') }" *ngIf="infrastructurePlanEnabled && !userService.getModoAcceso()">
          <a routerLink="/dossiersView/INFRASTRUCTUREPLAN" (click)="miniNavControl()" role="link" title="{{ 'InfrastructurePlan.title' }}">
            <i class="fa fa-clipboard-list" aria-hidden="true"></i>
            <span class="nav-label">{{ 'InfrastructurePlan.title' | translate }}</span>
          </a>
        </li>
        <li class="pb-1 pt-1" [ngClass]="{ active: activeRoute('dossiersView/SPENDINGPROJECTS') }" *ngIf="spendingProjectEnabled && !userService.getModoAcceso()">
          <a routerLink="/dossiersView/SPENDINGPROJECTS" (click)="miniNavControl()" role="link" title="{{ 'SpendingProjects.title' }}">
            <i class="fa fa-clipboard-list" aria-hidden="true"></i>
            <span class="nav-label">{{ 'SpendingProjects.title' | translate }}</span>
          </a>
        </li>
        <li class="pb-1 pt-1" [ngClass]="{ active: activeRoute('dossiersView/MAETD_REPORTREQUESTPROJECTS') }" *ngIf="userService.hasRolesInApp('INFORMESGAD') && !userService.getModoAcceso()">
          <a routerLink="/dossiersView/MAETD_REPORTREQUESTPROJECTS" (click)="miniNavControl()" role="link" title="{{ 'Peticiones de Informe' }}">
            <i class="fa fa-play" aria-hidden="true"></i>
            <span class="nav-label">Peticiones Informe</span>
          </a>
        </li>
        <li class="pb-1 pt-1" [ngClass]="{ active: activeRoute('dossierCreation') }" *ngIf="this.profileService.newDossierEnabled && !userService.getModoAcceso()">
          <a routerLink="/dossierCreation" (click)="miniNavControl()" role="link" title="{{ 'Navigation.dossierCreation' | translate }}">
            <i class="fas fa-plus" aria-hidden="true"></i>
            <span class="nav-label">{{ 'Navigation.dossierCreation' | translate }}</span>
          </a>
        </li>
        <li
          class="pb-1 pt-1"
          *plycaRbac="{
            dynamicRoles: rbacControl.CATALOGS.dynamicRoles,
            activeModules: rbacControl.CATALOGS.activeModules,
            profileApplication: rbacControl.CATALOGS.profileApplication
          }"
          [ngClass]="{ active: currentActiveRoute(routingPath.LoggedInCatalog) }"
        >
          <a [routerLink]="routingPath.LoggedInCatalog" [queryParams]="{ tab: 0 }" (click)="miniNavControl()" role="link" [title]="'Navigation.catalog' | translate">
            <i class="fa fa-shopping-cart" aria-hidden="true">
              @if (quantityPendingCart()?.quantityCart > 0) {
                <p [class]="'badge badge-cart ' + (isMiniNavbar ? 'badge-mini' : 'badge-danger')" aria-hidden="true" [innerHTML]="quantityPendingCart()?.quantityCart"></p>
              }
            </i>
            <span class="nav-label" [innerHTML]="'Navigation.catalog' | translate"></span>
          </a>
        </li>
        <li class="pb-1 pt-1" [ngClass]="{ active: activeRoute('contracts') }" *ngIf="newContractEnabled && !userService.getModoAcceso() && !adaptationAymadEnabled">
          <a routerLink="/contracts" (click)="miniNavControl()" role="link" title="{{ 'Contracts.new' | translate }}">
            <i class="fas fa-plus" aria-hidden="true"></i>
            <span class="nav-label">{{ 'Contracts.new' | translate }}</span>
          </a>
        </li>
        <li class="pb-1 pt-1" [ngClass]="{ active: activeRoute('contracts') }" *ngIf="newContractEnabled && !userService.getModoAcceso() && adaptationAymadEnabled">
          <a routerLink="/contractsaymad" (click)="miniNavControl()" role="link" title="{{ 'Contracts.new' | translate }}">
            <i class="fas fa-plus" aria-hidden="true"></i>
            <span class="nav-label">{{ 'Contracts.new' | translate }}</span>
          </a>
        </li>
        <li class="pb-1 pt-1" [ngClass]="{ active: activeRoute('budgetaryProject') }" *ngIf="newBudgetaryProjectEnabled && !userService.getModoAcceso()">
          <a routerLink="/budgetaryProject" (click)="miniNavControl()" role="link" title="Expedientes Presupuestarios">
            <i class="fas fa-plus-circle" aria-hidden="true"></i>
            <span class="nav-label">Nuevo Expediente Presupuestario</span>
          </a>
        </li>
        <li class="pb-1 pt-1" [ngClass]="{ active: activeRoute('orderproject') }" *ngIf="newOrderProjectEnabled && !userService.getModoAcceso()">
          <a routerLink="/orderproject" (click)="miniNavControl()" role="link" title="Expedientes Encargo">
            <i class="fas fa-plus-circle" aria-hidden="true"></i>
            <span class="nav-label">Nuevo Expediente Encargo</span>
          </a>
        </li>
        <li class="pb-1 pt-1" [ngClass]="{ active: activeRoute('searchDocuments') }" *ngIf="documentSearchEnabled">
          <a routerLink="/searchDocuments" (click)="miniNavControl()" role="link" title="{{ 'Documents.search' | translate }}">
            <span class="fa-stack">
              <i class="fas fa-file fa-stack-2x"></i>
              <i class="fas fa-search fa-stack-1x"></i>
            </span>
            <span class="nav-label">{{ 'Documents.search' | translate }}</span>
          </a>
        </li>
        <li
          class="pb-1 pt-1"
          [class]="{
            active:
              activeRoute('logs') ||
              activeRoute('monitorization') ||
              activeRoute('eventAudit') ||
              activeRoute('license') ||
              activeRoute('actions') ||
              activeRoute('timers') ||
              activeRoute('sessions') ||
              activeRoute('validations') ||
              activeRoute('helpAdmin') ||
              activeRoute('companyList') ||
              activeRoute('dossierModels') ||
              activeRoute('formulas') ||
              activeRoute('controlPanel') ||
              activeRoute(routingPath.LoggedInSignatureTool) ||
              activeRoute(routingPath.LoggedInProductMaintenance) ||
              activeRoute(routingPath.LoggedInConfiguration)
          }"
          *ngIf="this.profileService.isShowControlPanelMenuOption() && !userService.getModoAcceso()"
        >
          <a routerLink="/controlPanel" (click)="miniNavControl()" role="link" title="{{ 'General.utils' | translate }}">
            <i class="fa fa-cogs" aria-hidden="true"></i>
            <span class="nav-label">{{ 'General.utils' | translate }}</span>
          </a>
        </li>
        <li class="pb-1 pt-1" [ngClass]="{ active: activeRoute('reports') }" *ngIf="!userService.getModoAcceso()">
          <a routerLink="/reports" (click)="miniNavControl()" role="link" title="{{ 'General.reports' | translate }}">
            <i class="fa fas fa-database" aria-hidden="true"></i>
            <span class="nav-label">{{ 'General.reports' | translate }}</span>
          </a>
        </li>
        <li class="pb-1 pt-1" [ngClass]="{ active: activeRoute('userGuide') }">
          <a (click)="showGeneralGuide()" (keyup.enter)="showGeneralGuide()" role="link" title="{{ 'General.guide' | translate }}">
            <i class="fa fa-desktop" aria-hidden="true"></i>
            <span class="nav-label">{{ 'General.guide' | translate }}</span>
          </a>
        </li>
        <li class="pb-1 pt-1" [ngClass]="{ active: activeRoute(routingPath.LoggedInGeneralHelp) }">
          @if (!isDesktop()) {
            <a [routerLink]="routingPath.LoggedInGeneralHelp" (click)="miniNavControl()" role="link" [title]="'General.ayuda' | translate">
              <i class="fa fa-question" aria-hidden="true"></i>
              <span class="nav-label">{{ 'General.ayuda' | translate }}</span>
            </a>
          } @else {
            <a role="link" [title]="'General.ayuda' | translate" (click)="onClickOpenHelp()" (keyup.enter)="onClickOpenHelp()" tabindex="0">
              <i class="fa fa-question" aria-hidden="true"></i>
              <span class="nav-label">{{ 'General.ayuda' | translate }}</span>
            </a>
          }
        </li>
        <li *ngIf="adaptationCixtecIntegrationBitacoraEnabled" class="pb-1 pt-1" [ngClass]="{ active: activeRoute('newSupportEvent') }">
          <a routerLink="/newSupportEvent" (click)="miniNavControl()" role="link">
            <i class="fas fa-headset" aria-hidden="true"></i>
            <span class="nav-label">Soporte</span>
          </a>
        </li>
      </ul>
    </p-scrollPanel>
  </div>
  <div class="p-2 infoplyca">
    <strong class="d-block">{{ 'Footer.plyca' | translate }}</strong>
    <small class="d-block">{{ authService.getVersion() }}</small>
    <span class="text-danger d-block">{{ 'Footer.nexus' | translate }}</span>
    <span>{{ 'Footer.copy' | translate }}</span>
  </div>
</nav>
<p-dialog
  header="{{ 'General.guide' | translate }}"
  [(visible)]="showModal"
  [responsive]="true"
  [modal]="true"
  [resizable]="false"
  [closable]="true"
  [dismissableMask]="true"
  [closeOnEscape]="false"
  [blockScroll]="true"
  [style]="{ width: '100vh' }"
>
  <p-scrollPanel [style]="{ width: '100%', height: '50vh' }" styleClass="custombar1 ">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 m-t-md">
          <table class="col-12">
            <tbody>
              <tr *ngFor="let item of helpElements">
                <td>
                  <a (click)="showGeneralGuide(item)" class="i-checks text-center">
                    <span>{{ item.shortDesc != null && item.shortDesc !== '' ? item.shortDesc : ('General.' + item | translate) }}</span>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </p-scrollPanel>
</p-dialog>
